const SearchBar = () => {
    return (
      <div className="nav-item nav-search-inputs me-auto">
        {/* Placeholder for Search Input */}
      </div>
    );
  };
  
  export default SearchBar;
  